/*
 * ELASTICSEARCH CONFIDENTIAL
 * __________________
 *
 *  Copyright Elasticsearch B.V. All rights reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Elasticsearch B.V. and its suppliers, if any.
 * The intellectual and technical concepts contained herein
 * are proprietary to Elasticsearch B.V. and its suppliers and
 * may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright
 * law.  Dissemination of this information or reproduction of
 * this material is strictly forbidden unless prior written
 * permission is obtained from Elasticsearch B.V.
 */

import { connect } from 'react-redux'

import { ThunkDispatch } from '@/types/redux'
import { getSecurityCluster } from '@/apps/adminconsole/reducers/securityCluster'
import {
  fetchSecurityClusterRequest,
  createSecurityClusterRequest,
} from '@/apps/adminconsole/reducers/registry'

import { createSecurityCluster, fetchSecurityCluster } from '../../../apps/adminconsole/actions'

import RbacStatus from './RbacStatus'

import type { StateProps, DispatchProps, ConsumerProps } from './RbacStatus'

const mapStateToProps = (state, { regionId }) => ({
  securityCluster: getSecurityCluster(state, regionId),
  createRequest: createSecurityClusterRequest(state, regionId),
  fetchRequest: fetchSecurityClusterRequest(state, regionId),
})

const mapDispatchToProps = (dispatch: ThunkDispatch, { regionId }) => ({
  onCreate: () => dispatch(createSecurityCluster(regionId)),
  onFetch: () => dispatch(fetchSecurityCluster(regionId)),
})

export default connect<StateProps, DispatchProps, ConsumerProps>(
  mapStateToProps,
  mapDispatchToProps,
)(RbacStatus)
